// Throwaway email addresses, and the one key that says two addresses are the
// same inbox (billing plan §7: "verified email required; throwaway domains
// refused"). The SAME list is seeded into rb_throwaway_domains by migration
// 20261013000007 — the database is the lock, this file only lets the sign-up
// forms say so before anyone waits for an email. A test holds the two lists
// together.
//
// ⚠️ A SHORT, HAND-PICKED LIST of the services people actually reach for, not
// the 100,000-entry public lists: those carry real ISPs and small-town
// providers by mistake, and someone on their co-op's email must never be
// told his address is fake. Add a domain when the Review list shows it.

export const THROWAWAY_DOMAINS: readonly string[] = [
  "10minutemail.com", "10minutemail.net", "20minutemail.com", "33mail.com", "anonaddy.me", "burnermail.io",
  "byom.de", "discard.email", "discardmail.com", "dispostable.com", "dropmail.me", "emailondeck.com",
  "emltmp.com", "fakeinbox.com", "fakemail.net", "getairmail.com", "getnada.com", "guerrillamail.biz",
  "guerrillamail.com", "guerrillamail.de", "guerrillamail.info", "guerrillamail.net", "guerrillamail.org",
  "guerrillamailblock.com", "harakirimail.com", "inboxbear.com", "inboxkitten.com", "incognitomail.org",
  "jetable.org", "mail-temp.com", "mail.tm", "mailcatch.com", "maildrop.cc", "mailinator.com",
  "mailinator.net", "mailnesia.com", "mailpoof.com", "mailsac.com", "mintemail.com", "moakt.com",
  "mohmal.com", "mytemp.email", "nada.email", "sharklasers.com", "spam4.me", "spambox.us",
  "spamgourmet.com", "temp-mail.io", "temp-mail.org", "tempail.com", "tempinbox.com", "tempmail.com",
  "tempmail.dev", "tempmail.net", "tempmailo.com", "tempr.email", "throwawaymail.com", "trashmail.com",
  "trashmail.de", "trashmail.net", "yopmail.com", "yopmail.fr", "yopmail.net",
];

const SET = new Set(THROWAWAY_DOMAINS);

export function emailDomain(email: string): string {
  return email.trim().toLowerCase().split("@").pop() ?? "";
}

export function isThrowawayEmail(email: string): boolean {
  return SET.has(emailDomain(email));
}

/** One inbox, one key: lower case; "+anything" dropped; Gmail's dots dropped
 *  and googlemail.com read as gmail.com. Matches rb_email_key() in SQL. */
export function emailKey(email: string): string {
  const e = email.trim().toLowerCase();
  const at = e.lastIndexOf("@");
  if (at < 0) return e;
  let local = e.slice(0, at).split("+")[0];
  let domain = e.slice(at + 1);
  if (domain === "googlemail.com") domain = "gmail.com";
  if (domain === "gmail.com") local = local.replace(/\./g, "");
  return `${local}@${domain}`;
}

/** The sign-up forms' words. */
export const THROWAWAY_MESSAGE = "Please use your regular email. Throwaway addresses can't start a free month.";

/** This browser's id, kept so the Review list can see two accounts made on
 *  one device. Random, stored only here; null when storage is blocked. */
export function deviceId(): string | null {
  try {
    let id = localStorage.getItem("rb_device");
    if (!id) {
      id = typeof crypto !== "undefined" && "randomUUID" in crypto ? crypto.randomUUID() : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("rb_device", id);
    }
    return id;
  } catch {
    return null;
  }
}
